import React from 'react'
import { Image } from 'primereact/image';
import Spinner from './Spinner';
import { imageExtensionValidation, pdfExtensionValidation } from '../utilitties/fileValidation';


export type ViewerFormats = 'pdf' | 'jpg' | 'png' |'jpeg' |'gif' |'bmp' |'tiff' |'svg';

export const Viewer: (props: { format: ViewerFormats, loading: boolean, base64: any, fileStyle?: React.CSSProperties }) => JSX.Element = ({ format, loading, base64, fileStyle }) => {
  if (loading) return <Spinner/>
  if (base64 == undefined || base64 == null || base64 == '') {
    return <div style={{...fileStyle, display: 'flex', justifyContent: 'center', alignItems: 'center'}}><p style={{fontSize: '3rem', fontWeight: 'bold'}}>No se encontro el archivo.</p></div>
  }

  if (imageExtensionValidation(format) ) {
    let formatter:string = `data:image/${format};base64`;
    return (
      <div style={fileStyle}>
        <Image src={`${formatter},${base64}`} alt="Image" imageStyle={{ width: '100%', height: '100%', objectFit: 'contain' }}/>
      </div>
    )
  }
  if (pdfExtensionValidation(format) ) {
    let formatter:string = `data:application/pdf;base64`;
    return (
      <div style={fileStyle}>
        <embed src={`${formatter},${base64}`} style={{ minWidth: '100%', minHeight: '100%' }} />
      </div>
    );
  }else{
    return <div style={{...fileStyle, display: 'flex', justifyContent: 'center', alignItems: 'center'}}><p style={{fontSize: '3rem', fontWeight: 'bold'}}>Formato no soportado</p></div>
  }
 


}


